<script lang="ts" setup>
    import { storeToRefs } from 'pinia'
    import { useQuasar } from 'quasar'
    import { useAppStore } from '~~/stores/app'
    
    const $q = useQuasar()
    const appStore = useAppStore()
    
    const { themeMode } = storeToRefs(appStore)

    watch(
        themeMode,
        (newMode) => {
            const darkValue = newMode === 'auto' ? 'auto' : newMode === 'dark'
            $q.dark.set(darkValue)
        },
        { immediate: true },
    )
</script>

<template>
    <nuxt-layout>
        <nuxt-page />
    </nuxt-layout>
</template>
